<template>
  <div v-if="debug">
    <navbar class="debug-actions">
      <template slot="collapse-btn"><span></span></template>
      <ul class="nav nav-pills">
        <li v-for="(a, i) in list" :key="`${uid}-${i}`">
          <a role="button"
             class="debug-actions-button"
             @click.stop="call(a)"
             v-tooltip.unenterable="a.tooltip">
            <span class="glyphicon"
                  :class="`glyphicon-${a.icon}`"
                  aria-hidden="true">
            </span>
            <span class="hidden-xs hidden-sm">{{ a.text }}</span>
          </a>
        </li>
      </ul>
    </navbar>
  </div>
</template>
<script>

const impl = {
  tooltip: function (t) {
    if (t == null) {
      return ''
    }

    const tooltip = t.tooltip ? t.tooltip() : t.text

    return `<span class="hint-tooltip">${tooltip}<br />${t.keyText}</span>`
  }
}

export default {
  name: 'debug-actions',

  props: {
    actions: {
      type: Array,
      required: true
    }
  },

  methods: {
    call: function (a) {
      a.action(a.param)
    }
  },

  computed: {
    debug: function () {
      return process.env.VUE_APP_SPIADI_DEBUG === '1'
    },

    list: function () {
      if (!this.debug) {
        return []
      }

      const result = []

      for (let i = 0; i !== this.actions.length; ++i) {
        const a = this.actions[i]
        const item = {
          action: a.action,
          param: a.param,
          tooltip: impl.tooltip(a),
          icon: a.icon,
          text: a.text
        }

        result.push(item)
      }
      return result
    },

    uid: function () {
      return `debug-actions-${this._uid}`
    }
  }
}
</script>
<style lang="less" scoped>
@import '~variables';
.debug-actions {
  padding-top: 0.8rem;
  li.disabled {
    opacity: 0.3;
    a {
      background-color:  @base;
      color: white;
      border: 1px solid @base;
    }

    a:hover {
      background-color:  @base;
      color: white;
      border-color: @darker-base;
    }
  }

  li {
    a {
      background-color:  @base;
      color: white;
      border: 1px solid @base;
    }

    a:hover {
      background-color:  @darker-base;
      border-color: @darker-base;
    }
  }

  li.success.disabled {
    a {
      background-color: @brand-success;
      border: 1px solid @brand-success;
    }

    a:hover {
      background-color: @brand-success;
    }
  }

  li.success {
    a {
      background-color: @brand-success;
      border: 1px solid @brand-success;
    }

    a:hover {
      background-color: darken(@brand-success, 20%);
      border-color: darken(@brand-success, 20%);
    }
  }
}

.debug-actions {
  margin-bottom: 0px;
  border-radius: 0px;
  border-top: 0px;
  border-bottom: 0px;
  border-left: 0px;

  li.active {
    opacity: 1;
    a {
      background-color: @darker-base;
      border: 1px solid @darker-base;
    }
  }

  li.active.success {
    a {
      background-color: darken(@brand-success, 20%);
      border: 1px solid darken(@brand-success, 20%);
    }
  }
}

.debug-actions-button {
  padding: 6px 12px;
  .glyphicon {
    font-size: 100%;
    margin-right: 0.4rem;
  }
  font-size: 100%;
}
</style>
